import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { capitalizeCountryName } from 'javascripts/analytics/utils/country_names';

export class CountryFlag extends React.Component {
  static propTypes = {
    country: PropTypes.object.isRequired,
    tooltip: PropTypes.bool,
  };

  countryNameForCountryCode = () => {
    const name = this.props.country.countryName || this.props.country.name;
    if (name) {
      return capitalizeCountryName(name);
    }
    return 'Unknown';
  };

  initializeCountryTooltip = (el) => {
    if (!el) return;
    $(el).tooltip({
      title: this.countryNameForCountryCode(),
    });
  };

  countryCode = () => {
    // Hacky fix for differences in data formatting
    if (this.props.country.code) {
      return this.props.country.code;
    } else if (this.props.country.countryCode) {
      return this.props.country.countryCode;
    } else {
      return '';
    }
  };

  render() {
    return (
      <span
        className={'flag flag-' + this.countryCode()}
        ref={this.props.tooltip && this.initializeCountryTooltip}
      />
    );
  }
}
